/* eslint-disable no-unused-vars */
const getters = {
  namespaced: true,
  actions: {
    findData ({ commit, state, dispatch }, { set, ids }) {
      if (set && ids) {
        let data = this.state.data[set] || []
        let list = ids.toString().split(',')
        let items = data.filter(e => list.includes(e.id.toString())) || false
        return items
      }
      return false
    }
  }
}

export default getters
